export default {
    day: '2023-10-18',
    content: {
        village: [
            {
                type: 'clarity',
                text: '178'
            }
        ],
        horde: [
            {
                type: 'new',
                text: '172'
            },
            {
                unlock: 'hordePrestige',
                type: 'new',
                text: '173'
            },
            {
                unlock: 'hordeEquipment',
                type: 'bugfix',
                text: '174'
            },
            {
                unlock: 'hordePrestige',
                type: 'bugfix',
                text: '176'
            },
            {
                unlock: 'hordePrestige',
                type: 'qol',
                text: '177'
            }
        ],
        achievement: [
            {
                type: 'balance',
                text: '175'
            }
        ]
    }
}
